/*
 * Project: Dynamedics Portal Web
 * Created Date: Monday July 5th 2021
 * Author: Chamudi Vidanagama
 * -----
 * Last Modified: Monday July 5th 2021 10:24:54 am
 * Modified By: Chamudi Vidanagama at <cvidanagama@mitrai.com>
 * -----
 * Copyright (c) 2021 Mitra Sparks
 * -----
 * HISTORY:
 * 2021-08-23	NRB	Changed API endpoints.
 * 2021-11-02 SS added endpints for communications/feedbacks
 * 2022-01-27 SS changed approveRequest/respondToquestion to multiple receivers
 */

import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  questions: [],
  requests: [],
  feedbacks: []
};

const slice = createSlice({
  name: 'communication',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // FINISHED LOADING
    finishLoading(state) {
      state.isLoading = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET QUESTIONS
    getQuestionsSuccess(state, action) {
      state.isLoading = false;
      state.questions = action.payload;
    },

    // GET REQUESTS
    getRequestsSuccess(state, action) {
      state.isLoading = false;
      state.requests = action.payload;
    },
    getFeedbacksSuccess(state, action) {
      state.isLoading = false;
      state.feedbacks = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getQuestions() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/communications/questions');
      dispatch(slice.actions.getQuestionsSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getRequests(filters) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/communications/requests', {
        params: { ...filters }
      });
      dispatch(slice.actions.getRequestsSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function approveRequest(requestIds, action) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.post('/communications/request/status', {
        action: action,
        ids: requestIds
      });
      dispatch(slice.actions.finishLoading());
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}
// ----------------------------------------------------------------------
export function respondToQuestion(questionIds, response) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.post('/communications/question', {
        ids: questionIds,
        response: response
      });
      dispatch(slice.actions.finishLoading());
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

//------------------------------------------------------------------------------

export function getFeedbacks() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/communications/feedbacks');
      dispatch(slice.actions.getFeedbacksSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

//-------------------------------------------------------------------------------
